module.exports = __webpack_public_path__ + "static/media/search-solid.c6a0effb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search-solid.svg
// module id = 1114
// module chunks = 58